var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('div', {
    staticClass: "target-practice focusable",
    attrs: {
      "slot": "content",
      "id": "target-practice-container",
      "tabindex": "0"
    },
    slot: "content"
  }, [_vm.progress ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBothHands || _vm.holdKeyPressed || _vm.oneHandedTypingHand,
      expression: "showBothHands || holdKeyPressed || oneHandedTypingHand"
    }],
    staticClass: "target-practice-container"
  }, [_vm.isVisibleLeftHand ? _c('div', {
    class: ("target-practice-image-left " + (_vm.oneHandedTypingHand ? 'one-hand-typing-hand' : ''))
  }, [_c('div', {
    staticClass: "svg-image-container current-letter"
  }, [_c('svg', {
    attrs: {
      "width": "200px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.leftHand)
    }
  })])]) : _vm._e(), _vm.isVisibleRightHand ? _c('div', {
    class: ("target-practice-image-right " + (_vm.oneHandedTypingHand ? 'one-hand-typing-hand' : ''))
  }, [_c('div', {
    staticClass: "svg-image-container current-letter"
  }, [_c('svg', {
    attrs: {
      "width": "200px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.rightHand)
    }
  })])]) : _vm._e()]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }